import React, { BaseSyntheticEvent, useState } from 'react';
import styled from 'styled-components';
//
import Select from 'components/input/select';
import MenuItem from 'components/menu-item';
import Input from 'components/formula-entry/marker-search-box';
import { ESearchFilter } from 'store/deals/types';
import { IFieldOption } from 'store/field-options/types';
import colors from 'theme/colors';
import uuid from 'uuid';

const { darkInputBorder } = colors;

const Container = styled.div`
  display: flex;

  input {
    width: 200px;
  }
`;

const SelectContainer = styled.div`
  display: flex;
  border: 1px solid ${darkInputBorder};
  border-radius: 3px;
  margin-right: 8px;
  padding: 0px 8px 0px 16px;
  min-width: 100px;
  .MuiInput-underline:hover:not(.Mui-disabled):before,
  .MuiInput-underline:before {
    border-bottom: none;
  }
`;
interface IDealSearchProps {
  searchFilter: ESearchFilter;
  statusFilter: string;
  searchKeyword: string;
  setDealSearchFilter: (searchFilter: ESearchFilter) => void;
  setDealSearchKeyword: (searchKeyword: string) => void;
  statuses?: IFieldOption[];
  setDealSearchStatusFilter: (value: string) => void;
}

export default ({
  searchFilter,
  statusFilter,
  searchKeyword,
  setDealSearchFilter,
  setDealSearchKeyword,
  statuses,
  setDealSearchStatusFilter,
}: IDealSearchProps) => {
  function handleDealSearchFilterChange(e: BaseSyntheticEvent) {
    setDealSearchFilter(e.target.value);
  }
  function handleDealSearchStatusFilterChange(value: string) {
    setDealSearchStatusFilter(value);
  }
  const [status, setStatus] = useState(statusFilter);
  return (
    <Container>
      <SelectContainer>
        <Select
          labelId="select-label-status"
          id="select-status"
          value={status}
          onChange={(e: BaseSyntheticEvent) => {
            setStatus(e.target.value);
            handleDealSearchStatusFilterChange(e.target.value);
          }}
        >
          <MenuItem value="all">Select Status</MenuItem>
          {statuses?.map((statusData: IFieldOption) => (
            <MenuItem key={uuid()} value={statusData.name}>
              {statusData.displayName}
            </MenuItem>
          ))}
        </Select>
      </SelectContainer>
      <SelectContainer>
        <Select data-testid="tid-deal-search-dropdown" value={searchFilter} onChange={handleDealSearchFilterChange}>
          <MenuItem data-testid="tid-deal-search-dropdown-all" value={ESearchFilter.ALL}>
            All Deals
          </MenuItem>
          <MenuItem data-testid="tid-deal-search-dropdown-mine" value={ESearchFilter.MINE}>
            My Deals
          </MenuItem>
        </Select>
      </SelectContainer>
      <Input
        value={searchKeyword}
        onChange={(e: BaseSyntheticEvent) => setDealSearchKeyword(e.target.value)}
        onClear={() => setDealSearchKeyword('')}
      />
    </Container>
  );
};
